import React from 'react';
import { useParams } from 'react-router-dom';

import { Text } from '../atoms/Text';
import { Heading } from '../atoms/Heading';
import { Field } from '../molecules/Field';
import { Button } from '../atoms/Button';

import { InfoCard } from '../../components/molecules/InfoCard';
import Illustration from '../molecules/Illustration';

function BarrierForm({ back, options }) {
    let { pathway } = useParams();

    let know = '';
    let title = '';

    switch (pathway) {
        case 'alcohol':
            know =
                'Reducing your alcohol intake will improve your long term physical and mental health and leave you feeling more energetic.';
            title = 'drinking less';
            break;
        case 'smoking':
            know =
                'Stopping smoking will improve the health of pretty much your whole body, and make you less likely to suffer from lots of different health problems.';
            title = 'smoking less';
            break;
        case 'weight':
            know =
                'Managing weight can raise your energy levels, improve the quality of your sleep, and boost your mood.';
            title = 'managing weight';
                break;
        default:
            // activity
            know =
                'Physical activity can improve your energy levels, fitness, strength and mobility, and boost your mood.';
            title = 'getting active';
        }

    return (
        <div className="flex flex-col gap-3">
            <div className="h-auto">
                <Illustration type={`barrier-${pathway}`} classes="w-full object-center" />
            </div>
            <div className="flex flex-col gap-4 px-6 py-3 md:py-5 md:px-12">
                <Text>Step 2 of 3</Text>
                <Heading h1>What&apos;s stopping you from {title}?</Heading>

                <Text body>
                    Based on what my expert team says, it's always best to focus as much as possible. Try to pick out
                    your biggest barrier, and you can always come back later to try the Habit Hacker with another one!
                </Text>

                <InfoCard
                    classes="my-4"
                    childrenComponent={
                        <div className="flex flex-col gap-2 pl-2">
                            <Heading h3 classes="font-bold">
                                Did you know?
                            </Heading>
                            <Text body2 classes="normal-case">
                                {know}
                            </Text>
                        </div>
                    }
                />

                <Field
                    name="barrier"
                    label="Select the 1 option you struggle with most:"
                    input="radio"
                    isRequired
                    inputOptions={{
                        options,
                    }}
                />

                <div className="flex flex-col gap-3 p-5 border-2 border-primary-200 rounded-xl">
                    <Heading h3 classes="font-semibold text-22">
                        Not sure which option to pick?
                    </Heading>
                    <Text body>
                        If your main barrier is also closely related to another area, try exploring one of our other
                        goals to see if the options are more relevant for you. Alternatively, get in touch with our
                        expert team to receive advice tailored to your situation as part of our free service for Dorset
                        residents.
                    </Text>
                    <Button
                        label="Try Another goal"
                        mode="secondary"
                        classes="flex justify-center"
                        onClick={() => back(0)}
                    />
                </div>
            </div>
        </div>
    );
}

export default BarrierForm;
